<template>
  <div class="itemdiv left">
    <li class="linecourseli">
      <img class="cover" :src="item.img" alt />
      <p class="courseName">教学课程制作</p>
      <p class="teachName">张军教授</p>
    </li>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
.linecourseli {
  width: 228px;
  background: #fff;
  height: 220px;
}
.itemdiv {
  margin-right: 15px;
  height: 220px;
}
.itemdiv:last-child {
  margin-right: 0;
}
.cover {
  width: 228px;
  height: 130px;
}
</style>